import axios from "axios";

const adobeTypekitParser = async (url) => {
  const response = await axios.get(url);
  const text = response.data;

  let fonts = [];
  let importUrl = "";
  const importRegex = /@import\s*url\("(.*?)"\);/;
  const importMatch = importRegex.exec(text);

  if (importMatch) {
    importUrl = `@import url(${importMatch[1]});`;
  }

  const fontFaceRegex = /@font-face\s*{([\s\S]*?)}/g;
  let fontFaceMatch;
  while ((fontFaceMatch = fontFaceRegex.exec(text)) !== null) {
    const fontface = `@font-face {${fontFaceMatch[1]}}`;

    const fontFamilyRegex = /font-family:"(.*?)"/;
    const fontFamilyMatch = fontFamilyRegex.exec(fontface);

    if (fontFamilyMatch) {
      const name = fontFamilyMatch[1];
      fonts.push({ name, fontface });
    }
  }

  if ([...new Set(fonts.map((f) => f.name))].length !== fonts.length) {
    fonts = [fonts.shift()];
  }
  return { fonts, importUrl };
};

export { adobeTypekitParser };
